import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

// Per-user persisted collapse state for collapsible sections (Jun 2026).
// Originally payroll-only; storage prefix kept for backwards compatibility.
export const useCollapsePref = (sectionKey, defaultOpen = false) => {
  const { user } = useAuth();
  const storageKey = `payroll-collapse:${user?.id || ''}:${sectionKey}`;
  const [open, setOpen] = useState(() => {
    try {
      const v = localStorage.getItem(storageKey);
      if (v === 'open') return true;
      if (v === 'closed') return false;
      return defaultOpen;
    } catch { return defaultOpen; }
  });
  // Re-sync when the auth user hydrates after mount (storage key changes).
  useEffect(() => {
    try {
      const v = localStorage.getItem(storageKey);
      if (v === 'open') setOpen(true);
      else if (v === 'closed') setOpen(false);
    } catch { /* noop */ }
  }, [storageKey]);
  const toggle = () => setOpen((o) => {
    const next = !o;
    try { localStorage.setItem(storageKey, next ? 'open' : 'closed'); } catch { /* noop */ }
    return next;
  });
  return [open, toggle];
};
